<template>
 <div id="page-content" ref="list-top">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div v-if="loading" class="page-loader-inline">
            <div class="loading-spinner-wrap">
              <div class="loading-spinner"></div>
              <div class="loading-spinner-inner"></div>
            </div>
            <p>載入中...</p>
          </div>
          <course-list-view
            v-if="display=='LIST' && !loading"
            :loading="loading"
            :pagedItems="pagedItems"
            :category="category"
            :total="total"
            :currentPage="currentPage"
            :perPage="perPage"
            :model="filterModel"
            @sortFromView="setSortFromView($event, arguments[1])"
            @pageChange="changePage($event)"
            @showDetails="storeStatus('courses')"
            @filterOnChange="handleFilterChange"
            @reset="handleReset">
          </course-list-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import * as mixin from './CourseListMixin.vue';
    let courseList = Vue.extend({
        mixins:[mixin],
        data() {
            return {
                filterModel: {
                    keyword: '',
                    institutions: {},
                    levels: {},
                    modes: {},
                    areas: {},
                    awards: {},
                    financeTypes: {}
                }
            };
        },
        mounted() {
        },
        methods: {
            changePage(page) {
                this.currentPage = page;
                this.setPage(page);
            },
            handleFilterChange(model) {
                this.filterModel = model;
                this.model = model;
                this.filter();
            },
            handleReset() {
                this.filterModel = {
                    keyword: '',
                    institutions: {},
                    levels: {},
                    modes: {},
                    areas: {},
                    awards: {},
                    financeTypes: {}
                };
                this.reset();
            }
        }
    });
    export default courseList;
</script>



// WEBPACK FOOTER //
// resources/js/course_new/CourseList.vue